export enum TemplateNames {
  RecoveryPassword = 'Recovery password',
  PriceRequest = 'Price request',
  LikedObject = 'Liked object',
  ScheduledViewing = 'Scheduled viewing',
  ViewedObject = 'Viewed object',
  FeedbackForm = 'Feedback form',
  LandingForm = 'Landing form',
  SupportForm = 'Support form',
  TeamInvite = 'Team invite',
  PersonalOfferForm = 'Personal offer form',
  AddClient = 'Add client',
  RegisterClient = 'Register client',
  CreateQuiz = 'Create quiz',
}
